import ProjectMetricValue from './ProjectMetricValue'

/**
 * Kaart met een kop en een raster van meetwaarden — dezelfde getallen die in
 * het projectenoverzicht als kolommen naast elkaar staan, maar dan voor één
 * project onder elkaar.
 *
 * De foutmelding staat op de kaart zelf en niet boven de pagina: hij hoort bij
 * deze getallen, en zonder die tekst leest een rij vraagtekens als een defect.
 *
 * @param {object} props
 * @param {string} props.title - kop boven de kaart, bijvoorbeeld 'Theory of Change'
 * @param {string} [props.description] - regel onder de kop die uitlegt wat er geteld wordt
 * @param {Array<import('../../helpers/portfolio/projectMetricDefinitions').ProjectMetric>} props.metrics - welke meetwaarden
 * @param {Record<string, object> | null} props.byCompagnyId - tellingen per organisatie; null = nog geen antwoord
 * @param {string} props.compagnyId - de organisatie waar het om gaat
 * @param {string | null} [props.error] - foutmelding van de serveraanroep
 * @param {object} [props.project] - het CompagnyMeta-document, voor de contextvragen
 */
const ProjectMetricsCard = ({
    title,
    description,
    metrics,
    byCompagnyId,
    compagnyId,
    error = null,
    project = null,
}) => (
    <section className="project-metrics-card">

        <header className="project-metrics-card__header">
            <span className="project-detail-status-label">{title}</span>
            {description && <p className="project-metrics-card__description">{description}</p>}
        </header>

        {error && (
            <p className="project-metrics-card__error" role="alert">
                Deze tellingen konden niet opgehaald worden: {error}. Er staat daarom een
                vraagteken — het is dus niet gezegd dat er niets is.
            </p>
        )}

        <div className="project-metrics-card__grid">
            {metrics.map((metric) => (
                <div className="project-metric" key={metric.key}>
                    <span className="project-metric__label">{metric.label}</span>
                    <span className="project-metric__value">
                        <ProjectMetricValue
                            metric={metric}
                            byCompagnyId={byCompagnyId}
                            compagnyId={compagnyId}
                            failed={Boolean(error)}
                            project={project}
                        />
                    </span>
                </div>
            ))}
        </div>

    </section>
)

export default ProjectMetricsCard
